export type EntryGroup = {
  groupedBy: string;
  group: string;
  name: string;
  number: string | null;
  note: string | null;
  restrictions: Array<string>;
  duration: number;
  revenue?: number;
  budgetUsed?: boolean;
  hasBudgetRevenuesBilled?: boolean;
  hasBudgetRevenuesNotBilled?: boolean;
  hasNonBudgetRevenuesBilled?: boolean;
  hasNonBudgetRevenuesNotBilled?: boolean;
  hourlyRate?: number | null;
  hourlyRateIsEqualAndHasNoLumpsums?: boolean;
  durationWithoutRounding?: number;
  revenueWithoutRounding?: number;
  roundingSuccess?: boolean;
  subGroups?: Array<EntryGroup>;
};
